// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__JE2Nv","tabPanelStyle":"Tabs_tabPanelStyle__MEdCn","rootTabs":"Tabs_rootTabs__rzouN","TabsSelected":"Tabs_TabsSelected__gqJe8"};